/* app/js/src/components/common/volume-icon/volume-icon.component.scss */
/*# sourceMappingURL=volume-icon.component.css.map */
